module.exports = __webpack_public_path__ + "img/4 Blick in den Saal bei Ansprache.jpg";